import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PatientIdsDialogComponent } from '../../patient-ids-dialog/patient-ids-dialog.component';

@Component({
    selector: 'app-patient-id-display',
    templateUrl: './patient-id-display.component.html',
    styleUrls: ['./patient-id-display.component.scss'],
    standalone: false
})
export class PatientIdDisplayComponent {
  @Input() patient: any;
  @Input() userOwnerID: string;

  constructor(private dialog: MatDialog) {}

  get sortedPatientIDs(): any[] {
    if (!this.patient?.patientIDs) {
      return [];
    }
    // Sort so current ID is first
    let ids = [...this.patient.patientIDs];

    // If userOwnerID exists, place that ID first
    if (this.userOwnerID) {
      ids.sort((a, b) => {
        // If a is userOwnerID, it goes first
        if (a.id === this.userOwnerID && b.id !== this.userOwnerID) return -1;
        // If b is userOwnerID, it goes first
        if (b.id === this.userOwnerID && a.id !== this.userOwnerID) return 1;
        // Otherwise, sort so current ID is first
        if (a.current && !b.current) return -1;
        if (!a.current && b.current) return 1;
        return 0;
      });
    } else {
      // Sort so current ID is first
      ids.sort((a, b) => {
        if (a.current && !b.current) return -1;
        if (!a.current && b.current) return 1;
        return 0;
      });
    }
    let sortedPatientIDs = ids;
    return sortedPatientIDs;
  }

  get currentPatientID(): any {
    return this.sortedPatientIDs.find(id => id.current) || this.sortedPatientIDs[0];
  }

  get otherPatientIDs(): any[] {
    return this.sortedPatientIDs.filter(id => !id.current);
  }

  get hasMultipleIds(): boolean {
    return this.patient?.patientIDs && this.patient.patientIDs.length > 1;
  }

  showOtherPatientIds(): void {
    this.dialog.open(PatientIdsDialogComponent, {
      width: '500px',
      data: {
        patientIDs: this.otherPatientIDs,
        patientName: this.patient?.caseName || 'Patient'
      }
    });
  }
}
